// src/components/navbarLinks.js
import DashboardIcon from '@mui/icons-material/Dashboard';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import InventoryIcon from '@mui/icons-material/Inventory';
import CategoryIcon from '@mui/icons-material/Category';
import PersonIcon from '@mui/icons-material/Person';
import PaymentIcon from '@mui/icons-material/Payment';
import PeopleIcon from '@mui/icons-material/People';
import BusinessIcon from '@mui/icons-material/Business';
import SettingsIcon from '@mui/icons-material/Settings';
import BranchIcon from '@mui/icons-material/Business';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import GroupIcon from '@mui/icons-material/Group';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PaymentsIcon from '@mui/icons-material/Payments';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WorkIcon from '@mui/icons-material/Work';
import GroupsIcon from '@mui/icons-material/Groups';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import BadgeIcon from '@mui/icons-material/Badge';
import PaidIcon from '@mui/icons-material/Paid';
import DateRangeIcon from '@mui/icons-material/DateRange';
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import BalanceIcon from '@mui/icons-material/Balance';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import DescriptionIcon from '@mui/icons-material/Description';
import BedIcon from '@mui/icons-material/Bed';
import ChairIcon from '@mui/icons-material/Chair';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import ScaleIcon from '@mui/icons-material/Scale';
import RoomIcon from '@mui/icons-material/Room';
import CheckInIcon from '@mui/icons-material/HowToReg';
import CheckOutIcon from '@mui/icons-material/ExitToApp';
import RoomServiceIcon from '@mui/icons-material/RoomService';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import TableBarIcon from '@mui/icons-material/TableBar';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import DryCleaningIcon from '@mui/icons-material/DryCleaning';
import QrCodeIcon from '@mui/icons-material/QrCode';
import ChecklistIcon from '@mui/icons-material/Checklist';
import TodayIcon from '@mui/icons-material/Today';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CountertopsIcon from '@mui/icons-material/Countertops';
import SummarizeIcon from '@mui/icons-material/Summarize';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import ComputerIcon from '@mui/icons-material/Computer';
import AddIcon from '@mui/icons-material/Add';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ListIcon from '@mui/icons-material/List';
import AssignmentIcon from '@mui/icons-material/Assignment';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import TypeSpecimenIcon from '@mui/icons-material/TypeSpecimen';
import SourceIcon from '@mui/icons-material/Source';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import LayersIcon from '@mui/icons-material/Layers';
import ImageIcon from '@mui/icons-material/Image';
import DiscountIcon from '@mui/icons-material/Discount';
import EventIcon from '@mui/icons-material/Event';
import NightlifeIcon from '@mui/icons-material/Nightlife';
import HouseIcon from '@mui/icons-material/House';
import EventSeatIcon from '@mui/icons-material/EventSeat';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import SpaIcon from '@mui/icons-material/Spa';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';

// Helper function to get the current user session details
export const getCurrentUserInfo = () => {
    try {
        const userInfo = sessionStorage.getItem('userInfo');
        if (userInfo) {
            return JSON.parse(userInfo);
        }
    } catch (error) {
        console.error('Error getting user info:', error);
    }
    return null;
};

// Helper function to get current user type from session storage
export const getCurrentUserType = () => {
    const userInfo = getCurrentUserInfo();
    return userInfo?.user_type || 'other';
};

// Define visibility rules for each tab based on user type (for non-staff/admin users)
const getTabVisibility = (userType) => {
    const isClub = userType === 'club';
    const isOther = userType === 'other';
    
    return {
        customer: isClub || isOther, 
        hr: isClub || isOther,      
        units: isClub || isOther,   
        roomSettings: isOther,      
        eventManagement: isOther,   
        club: isClub,               
        guestHouse: isOther,        
        reservations: isOther,      
        bar: isOther,               
        restaurant: isOther,        
        settings: isClub || isOther 
    };
};

// Filter items for standard user roles
const filterMenuItem = (item, userType, visibilityMap) => {
    if (item.text === 'Main') {
        return item;
    }
    
    let tabKey = '';
    switch(item.text) {
        case 'Customer':
            tabKey = 'customer';
            break;
        case 'Human Resource':
            tabKey = 'hr';
            break;
        case 'Units':
            tabKey = 'units';
            break;
        case 'Room Settings':
            tabKey = 'roomSettings';
            break;
        case 'Event Management':
            tabKey = 'eventManagement';
            break;
        case 'Club':
            tabKey = 'club';
            break;
        case 'Guest House':
            tabKey = 'guestHouse';
            break;
        case 'Room Reservation':
        case 'Reservations':
            tabKey = 'reservations';
            break;
        case 'Bar':
            tabKey = 'bar';
            break;
        case 'Restaurant':
            tabKey = 'restaurant';
            break;
        case 'Settings':
            tabKey = 'settings';
            break;
        default:
            tabKey = '';
    }
    
    if (tabKey && !visibilityMap[tabKey]) {
        return null;
    }
    
    if (item.children && item.children.length > 0) {
        const filteredChildren = item.children
            .map(child => filterMenuItem(child, userType, visibilityMap))
            .filter(child => child !== null);
        
        if (filteredChildren.length === 0 && item.text !== 'Main') {
            return null;
        }
        
        return {
            ...item,
            children: filteredChildren
        };
    }
    
    return item;
};

// Filter items specifically for the staff ('ST') role
const filterStaffMenuItem = (item, hotelRole, userType) => {
    // Keep Dashboard/Main navigation accessible
    if (item.text === 'Main') {
        return item;
    }

    // 1- Staff + Bar Role
    if (hotelRole === 'bar') {
        if (item.text === 'Bar') {
            const posChild = item.children?.find(child => child.text === 'Pos');
            if (posChild) {
                return {
                    ...item,
                    children: [posChild]
                };
            }
        }
        return null;
    }

    // 2- Staff + Restaurant Role
    if (hotelRole === 'restaurant') {
        if (item.text === 'Restaurant') {
            const allowedChildren = item.children?.filter(
                child => child.text === 'POS Invoice' || child.text === 'Order List'
            ) || [];
            if (allowedChildren.length > 0) {
                return {
                    ...item,
                    children: allowedChildren
                };
            }
        }
        return null;
    }

    // 3- Staff + Club User Type
    if (userType === 'club') {
        if (item.text === 'Club') {
            const posChild = item.children?.find(child => child.text === 'Pos');
            if (posChild) {
                return {
                    ...item,
                    children: [posChild]
                };
            }
        }
        return null;
    }

    return null;
};

// Get filtered navigation links based on user role and configuration
export const getFilteredNavbarLinks = () => {
    const userInfo = getCurrentUserInfo();
    const userType = userInfo?.user_type || 'other';
    const role = userInfo?.role || '';
    const hotelRole = userInfo?.hotel_role || '';
    
    const visibilityMap = getTabVisibility(userType);
    
    const fullNavbarLinks = [
        {
            text: 'Main',
            icon: <DashboardIcon />,
            path: '/dashboard',
            description: 'System Overview'
        },
        {
            text: 'Customer',
            icon: <GroupIcon />,
            description: 'Customer Management',
            children: [
                {
                    text: 'Guest',
                    icon: <PersonIcon />,
                    path: '/customer/guest',
                    description: 'Guest information'
                },
                {
                    text: 'Pos Customers',
                    icon: <PeopleIcon />,
                    path: '/customer/type',
                    description: 'Pos Customer'
                },
            ]
        },
        {
            text: 'Human Resource',
            icon: <GroupsIcon />,
            description: 'HR Management',
            children: [
                {
                    text: 'Department',
                    icon: <BusinessIcon />,
                    description: 'Department Management',
                    children: [
                        {
                            text: 'Department',
                            icon: <BusinessIcon />,
                            path: '/hr-department/department',
                            description: 'All departments'
                        },
                    ]
                },
                {
                    text: 'Employee',
                    icon: <BadgeIcon />,
                    description: 'Employee Management',
                    children: [
                        {
                            text: 'Position',
                            icon: <WorkIcon />,
                            path: '/hr-employee/position',
                            description: 'Job positions'
                        },
                        {
                            text: 'Employee',
                            icon: <PersonIcon />,
                            path: '/hr-employee/employee',
                            description: 'Manage employees'
                        },
                        {
                            text: 'Salary',
                            icon: <PaidIcon />,
                            path: '/hr-employee/salary',
                            description: 'Salary management'
                        }
                    ]
                },
            ]
        },
        {
            text: 'Units',
            icon: <ScaleIcon />,
            description: 'Inventory Management',
            children: [
                {
                    text: 'Units',
                    icon: <ScaleIcon />,
                    path: '/units/units',
                    description: 'Units of measure'
                },
                {
                    text: 'Supplier',
                    icon: <LocalShippingIcon />,
                    path: '/units/suppliers',
                    description: 'Vendors list'
                }
            ]
        },
        {
            text: 'Room Settings',
            icon: <MeetingRoomIcon />,
            description: 'Room Configuration',
            children: [
                {
                    text: 'Categories',
                    icon: <RoomServiceIcon />,
                    path: '/room-settings/type',
                    description: 'All Categories'
                },
                {
                    text: 'Room',
                    icon: <RoomServiceIcon />,
                    path: '/room-settings/room',
                    description: 'All rooms'
                },
            ]
        },
        {
            text: 'Event Management',
            icon: <EventIcon />,
            description: 'Events Management',
            children: [
                {
                    text: 'Venue',
                    icon: <MeetingRoomIcon />,
                    path: '/event-management/venue',
                    description: 'Venue hiring and booking'
                },
                {
                    text: 'Chair',
                    icon: <EventSeatIcon />,
                    path: '/event-management/chair',
                    description: 'Event equipment rental'
                },
                {
                    text: 'Address System',
                    icon: <LocationCityIcon />,
                    path: '/event-management/address-system',
                    description: 'Event location management'
                },
                {
                    text: 'Decoration',
                    icon: <ImageIcon />,
                    path: '/event-management/decoration',
                    description: 'Event decoration services'
                },
                {
                    text: 'Tents',
                    icon: <PeopleIcon />,
                    path: '/event-management/tent',
                    description: 'Tents management'
                },
            ]
        },
        {
            text: 'Club',
            icon: <NightlifeIcon />,
            description: 'Club Management',
            children: [
                {
                    text: 'Dashboard',
                    icon: <DashboardIcon />,
                    path: '/club/common/dashboard',
                    description: 'Overview & Analytics'
                },
                {
                    text: 'Counter',
                    icon: <TableBarIcon />,
                    path: '/club/common/counter',
                    description: 'All Counters'
                },
                {
                    text: 'Day Clossing',
                    icon: <CountertopsIcon />,
                    path: '/club/common/day-clossing',
                    description: 'Day Clossing'
                },
                {
                    text: 'Pos',
                    icon: <AssessmentIcon />,
                    description: 'Club Pos',
                    children: [
                        {
                            text: 'POS Invoice',
                            icon: <PointOfSaleIcon />,
                            path: '/club/pos/pos',
                            description: 'POS billing'
                        },
                        {
                            text: 'Order List',
                            icon: <ReceiptLongIcon />,
                            path: '/club/pos/order',
                            description: 'All orders'
                        },
                    ]
                },
                {
                    text: 'Stock',
                    icon: <AssessmentIcon />,
                    description: 'Club Stock',
                    children: [
                        {
                            text: 'Stock',
                            icon: <CountertopsIcon />,
                            path: '/club/stock/stock',
                            description: 'Manage Stock'
                        },
                        {
                            text: 'Inventory',
                            icon: <CountertopsIcon />,
                            path: '/club/stock/inventory',
                            description: 'Club Inventories'
                        },
                        {
                            text: 'Adjustment',
                            icon: <InventoryIcon />,
                            path: '/club/stock/adjustment',
                            description: 'stock Adjustments'
                        }
                    ]
                },
                {
                    text: 'Reports',
                    icon: <AssessmentIcon />,
                    description: 'Club Reports',
                    children: [
                        {
                            text: 'Orders',
                            icon: <ShoppingBasketIcon />,
                            path: '/club/report/order',
                            description: 'Inventory report'
                        },
                        {
                            text: 'Inventory',
                            icon: <ShoppingBasketIcon />,
                            path: '/club/report/inventory',
                            description: 'Inventory report'
                        },
                        {
                            text: 'Stock',
                            icon: <InventoryIcon />,
                            path: '/club/report/stock',
                            description: 'Stock report'
                        },
                        {
                            text: 'Day Clossing',
                            icon: <SummarizeIcon />,
                            path: '/club/report/day-clossing',
                            description: 'Stock report'
                        }
                    ]
                },
            ]
        },
        {
            text: 'Guest House',
            icon: <HouseIcon />,
            description: 'Guests Management',
            children: [
                {
                    text: 'Guest',
                    icon: <PersonIcon />,
                    path: '/guest-house/guest-house',
                    description: 'Guest registration and management'
                },
                {
                    text: 'Venue',
                    icon: <MeetingRoomIcon />,
                    path: '/guest-house/venue-hiring',
                    description: 'Guest house venue booking'
                },
                {
                    text: 'Sauna',
                    icon: <SpaIcon />,
                    path: '/guest-house/sauna',
                    description: 'Sauna facility management'
                },
                {
                    text: 'Gym',
                    icon: <FitnessCenterIcon />,
                    path: '/guest-house/gym',
                    description: 'Gym facility management'
                },
            ]
        },
        {
            text: 'Reservations',
            icon: <BedIcon />,
            description: 'Booking Management',
            children: [
                {
                    text: 'Bookings',
                    icon: <BedIcon />,
                    path: '/reservation/booking',
                    description: 'All bookings'
                },
                {
                    text: 'Check In',
                    icon: <CheckInIcon />,
                    path: '/reservation/check-in',
                    description: 'Guest check-in'
                },
                {
                    text: 'Check Out',
                    icon: <CheckOutIcon />,
                    path: '/reservation/check-out',
                    description: 'Guest check-out'
                },
                {
                    text: 'Room Status',
                    icon: <RoomIcon />,
                    path: '/reservation/room-status',
                    description: 'Room availability'
                },
                {
                    text: 'Reports',
                    icon: <MenuBookIcon />,
                    path: '/reservation/report',
                    description: 'Report'
                }
            ]
        },
        {
            text: 'Bar',
            icon: <TableBarIcon />,
            description: 'Bar Management',
            children: [
                {
                    text: 'Dashboard',
                    icon: <DashboardIcon />,
                    path: '/bar/common/dashboard',
                    description: 'Overview & Analytics'
                },
                {
                    text: 'Day Clossing',
                    icon: <CountertopsIcon />,
                    path: '/bar/common/day-clossing',
                    description: 'Day Clossing'
                },
                {
                    text: 'Pos',
                    icon: <AssessmentIcon />,
                    description: 'Bar Pos',
                    children: [
                        {
                            text: 'POS Invoice',
                            icon: <PointOfSaleIcon />,
                            path: '/bar/pos/pos',
                            description: 'POS billing'
                        },
                        {
                            text: 'Order List',
                            icon: <ReceiptLongIcon />,
                            path: '/bar/pos/order',
                            description: 'All orders'
                        },
                    ]
                },
                {
                    text: 'Stock',
                    icon: <AssessmentIcon />,
                    description: 'Bar Stock',
                    children: [
                        {
                            text: 'Stock',
                            icon: <CountertopsIcon />,
                            path: '/bar/stock/stock',
                            description: 'Manage Stock'
                        },
                        {
                            text: 'Inventory',
                            icon: <CountertopsIcon />,
                            path: '/bar/stock/inventory',
                            description: 'Bar Inventories'
                        },
                        {
                            text: 'Adjustment',
                            icon: <InventoryIcon />,
                            path: '/bar/stock/adjustment',
                            description: 'stock Adjustments'
                        }
                    ]
                },
                {
                    text: 'Reports',
                    icon: <AssessmentIcon />,
                    description: 'Bar Reports',
                    children: [
                        {
                            text: 'Orders',
                            icon: <SummarizeIcon />,
                            path: '/bar/report/order',
                            description: 'Stock report'
                        },
                        {
                            text: 'Inventory',
                            icon: <ShoppingBasketIcon />,
                            path: '/bar/report/inventory',
                            description: 'Inventory report'
                        },
                        {
                            text: 'Stock',
                            icon: <InventoryIcon />,
                            path: '/bar/report/stock',
                            description: 'Stock report'
                        },
                        {
                            text: 'Day Clossing',
                            icon: <SummarizeIcon />,
                            path: '/bar/report/day-clossing',
                            description: 'Stock report'
                        }
                    ]
                },
            ]
        },
        {
            text: 'Restaurant',
            icon: <RestaurantIcon />,
            description: 'Restaurant Management',
            children: [
                {
                    text: 'Dashboard',
                    icon: <DashboardIcon />,
                    path: '/restaurant/common/dashboard',
                    description: 'POS billing'
                },
                {
                    text: 'POS Invoice',
                    icon: <PointOfSaleIcon />,
                    path: '/restaurant/pos/pos',
                    description: 'POS billing'
                },
                {
                    text: 'Order List',
                    icon: <ReceiptLongIcon />,
                    path: '/restaurant/pos/order',
                    description: 'All orders'
                },
                {
                    text: 'Manage Food',
                    icon: <FastfoodIcon />,
                    description: 'Menu Management',
                    children: [
                        {
                            text: 'Menu',
                            icon: <AddIcon />,
                            path: '/restaurant/food/food',
                            description: 'Food menu items'
                        },
                        {
                            text: 'Category',
                            icon: <AddIcon />,
                            path: '/restaurant/food/category',
                            description: 'New category'
                        },
                    ]
                },
                {
                    text:'Stock',
                    icon: <AssessmentIcon />,
                    description: 'Manage Stock',
                    children: [
                        {
                            text: 'Stock',
                            icon: <FastfoodIcon />,
                            path: '/restaurant/stock',
                            description: 'All Stock'
                        },
                        {
                            text: 'Inventory',
                            icon: <InventoryIcon />,
                            path: '/restaurant/inventory',
                            description: 'Inventory'
                        },
                        {
                            text: 'Adjustment',
                            icon: <InventoryIcon />,
                            path: '/restaurant/ingredient/adjustment',
                            description: 'Adjustment'
                        },
                    ]
                },
                // {
                //     text: 'Ingredients',
                //     icon: <AssessmentIcon />,
                //     description: 'Manage Ingredients',
                //     children: [
                //         {
                //             text: 'Ingredients',
                //             icon: <FastfoodIcon />,
                //             path: '/restaurant/ingredient/ingredient',
                //             description: 'All Ingredients'
                //         },
                //         {
                //             text: 'Inventory',
                //             icon: <InventoryIcon />,
                //             path: '/restaurant/ingredient/inventory',
                //             description: 'Inventory'
                //         },
                //         {
                //             text: 'Adjustment',
                //             icon: <InventoryIcon />,
                //             path: '/restaurant/ingredient/adjustment',
                //             description: 'Adjustment'
                //         },
                //     ]
                // },
                {
                    text: 'Reports',
                    icon: <AssessmentIcon />,
                    description: 'Restaurant Reports',
                    children: [
                        {
                            text: 'Stock',
                            icon: <ShoppingBasketIcon />,
                            path: '/restaurant/report/stock',
                            description: 'Stock report'
                        },
                        {
                            text: 'Order',
                            icon: <ShoppingBasketIcon />,
                            path: '/restaurant/report/order',
                            description: 'Inventory order'
                        },
                        {
                            text: 'Inventory',
                            icon: <ShoppingBasketIcon />,
                            path: '/restaurant/report/stock/inventory',
                            description: 'Inventory report'
                        },
                        // {
                        //     text: 'Inventory',
                        //     icon: <ShoppingBasketIcon />,
                        //     path: '/restaurant/report/inventory',
                        //     description: 'Inventory report'
                        // },
                        // {
                        //     text: 'Ingredients',
                        //     icon: <InventoryIcon />,
                        //     path: '/restaurant/report/ingredient',
                        //     description: 'Stock report'
                        // },
                    ]
                },
            ]
        },
        {
            text: 'Settings',
            icon: <SettingsIcon />,
            description: 'System Configuration',
            children: [
                {
                    text: 'User Management',
                    icon: <ManageAccountsIcon />,
                    path: '/settings/users',
                    description: 'Manage users'
                },
                // {
                //     text: 'Branch Management',
                //     icon: <BranchIcon />,
                //     path: '/settings/branch',
                //     description: 'Manage Branches'
                // }
            ]
        }
    ];
    
    // Determine which filtration system to apply
    let filteredLinks = [];
    if (role === 'ST') {
        filteredLinks = fullNavbarLinks
            .map(item => filterStaffMenuItem(item, hotelRole, userType))
            .filter(item => item !== null);
    } else {
        filteredLinks = fullNavbarLinks
            .map(item => filterMenuItem(item, userType, visibilityMap))
            .filter(item => item !== null);
    }
    
    return filteredLinks;
};

export const navbarLinks = getFilteredNavbarLinks();